module.exports = __webpack_public_path__ + "img/Ranger.dcf7c994.png";